// @ts-nocheck
import React from 'react'
import * as R from 'ramda'
import cx from 'classnames'

import { FeatureFlag } from 'components/auth/FeatureFlag'
import { Box } from 'components/layout/Box/Box'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Icon } from 'components/shared/Icon/Icon'

import styles from './DropdownMenu.module.scss'

export const DropdownMenu = ({ actions, className = undefined }) => (
  <Dropdown.Menu
    className={cx(styles.menu, { [className]: Boolean(className) })}
  >
    {R.map(
      ({
        icon,
        label,
        note,
        onClick,
        isDisabled,
        isFeatureFlagged,
        isLocked,
      }) => (
        <FeatureFlag key={label} show={isFeatureFlagged}>
          <Dropdown.MenuItem className={styles.item}>
            <Dropdown.Action
              className={styles.action}
              {...{ onClick, isDisabled, isLocked }}
            >
              <Icon
                className={cx(styles.icon, { [styles.locked]: isLocked })}
                icon={icon}
                size={24}
              />
              <Box align="flex-start" direction="column" tagName="span">
                <span className={styles.label}>{label}</span>
                <span className={styles.note}>{note}</span>
              </Box>
            </Dropdown.Action>
          </Dropdown.MenuItem>
        </FeatureFlag>
      ),
      actions,
    )}
  </Dropdown.Menu>
)
